import { message } from 'antd';
import { history } from '_helpers';
import { useFetchWrapper, useAuthWrapper } from '_helpers';

// Impersonation contract, shared by UsersTab (start) and Nav (banner + stop).
// The session swap happens server-side via httpOnly cookies; loadUser() re-reads
// /api/profile/me + /api/auth/me so the client picks up the new identity + caps.
// localStorage.impersonating is a non-secret UI marker for the "return" banner.
export function useImpersonation() {
    const fetchWrapper = useFetchWrapper();
    const authWrapper = useAuthWrapper();

    async function impersonate(studentId) {
        const res = await fetchWrapper.post(`/api/admin/impersonate/${studentId}`, null, null);
        const json = await res.json();
        if (json.status !== 'Success') { message.error(json.message || 'Không thể mạo danh'); return; }
        const admin = JSON.parse(localStorage.getItem('userData') || '{}');
        await authWrapper.loadUser();   // userData is now the target user
        localStorage.setItem('impersonating', JSON.stringify({
            target: json.message.name, adminName: admin.name || 'admin',
        }));
        message.success(`Đang xem với tư cách ${json.message.name}`);
        history.push('/');
        window.location.reload();       // hard refresh so every screen re-reads the new identity
    }

    async function stopImpersonate() {
        const res = await fetchWrapper.post('/api/admin/stop-impersonate', null, null);
        const json = await res.json();
        if (json.status !== 'Success') { message.error(json.message || 'Không thể quay lại admin'); return; }
        await authWrapper.loadUser();
        localStorage.removeItem('impersonating');
        history.push('/panel');
        window.location.reload();
    }

    return { impersonate, stopImpersonate };
}

export function getImpersonation() {
    try { return JSON.parse(localStorage.getItem('impersonating') || 'null'); }
    catch (_) { return null; }
}
